// Value-only enum used by paywall schemas. Kept separate from identsOverrides.ts
// so build-time tools (paywall-report.ts) can load paywall instances without
// pulling Pinia/Vue into Node — the runtime resolver in identsOverrides.ts depends on stores.
export enum IdentsOverrideId {
	ML_PRICE_DISCOUNT = 'ML_PRICE_DISCOUNT',
	ML_PRICE_PREMIUM = 'ML_PRICE_PREMIUM',
}
